var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isEmptyProduct && !_vm.isWebPlatform
    ? _c("div", { class: _vm.$style.emptyProduct }, [_vm._v("Coming Soon")])
    : _c(
        "div",
        { class: _vm.$style.orderPage },
        [
          _c("LoadingSpinner", {
            directives: [
              {
                name: "wait",
                rawName: "v-wait:visible",
                value: "preloadImage *",
                expression: "'preloadImage *'",
                arg: "visible"
              }
            ]
          }),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.$style.orderPageMenu },
            [
              _c("ConfiguratorCurrentBurger", {
                attrs: {
                  "configurator-category": _vm.currentCategory,
                  "sorted-categories": _vm.productSortedCategories
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { class: _vm.$style.orderPageContainer }, [
            _c(
              "div",
              { class: _vm.$style.stepsMenu },
              [
                _c(
                  "v-stepper",
                  {
                    class: _vm.$style.configurator,
                    model: {
                      value: _vm.currentCategory,
                      callback: function($$v) {
                        _vm.currentCategory = $$v
                      },
                      expression: "currentCategory"
                    }
                  },
                  [
                    _c(
                      "v-stepper-header",
                      { class: _vm.$style.stepsList },
                      [
                        _vm._l(_vm.allSortedCategories, function(
                          categoryKey,
                          index
                        ) {
                          return [
                            _c("ConfiguratorStepTitle", {
                              key: index + "step",
                              class: _vm.$style.step,
                              attrs: {
                                "last-step": false,
                                "current-step": _vm.currentCategory,
                                "category-key": categoryKey,
                                "steps-amount": _vm.categoriesLength
                              },
                              on: { stepChange: _vm.currentPageChange }
                            }),
                            _vm._v(" "),
                            _c("v-divider", { key: index + "stepDivider" })
                          ]
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("v-stepper-items", { class: _vm.$style.stepperItems }, [
                      _vm.isEmptyProduct && _vm.isWebPlatform
                        ? _c("div", { class: _vm.$style.emptyProduct }, [
                            _vm._v("Coming Soon")
                          ])
                        : _c(
                            "div",
                            { class: _vm.$style.stepsContentWrapper },
                            [
                              _vm._l(_vm.productSortedCategories, function(
                                categoryKey
                              ) {
                                return [
                                  categoryKey !== _vm.bossBundleCategoryId
                                    ? _c("ConfiguratorStepContent", {
                                        key: categoryKey + "-stepContent",
                                        attrs: {
                                          "category-key": categoryKey,
                                          "current-product": _vm.currentProduct,
                                          first: _vm.firstStepNoBundle(
                                            categoryKey
                                          ),
                                          last:
                                            !_vm.hasBundle &&
                                            categoryKey ===
                                              _vm.productSortedCategories[
                                                _vm.productSortedCategories
                                                  .length - 1
                                              ],
                                          "current-step": _vm.currentCategory,
                                          "lock-next-step": _vm.lockNextStep
                                        },
                                        on: {
                                          stepChange: _vm.currentPageChange
                                        }
                                      })
                                    : _vm._e()
                                ]
                              }),
                              _vm._v(" "),
                              !_vm.kidsMenu
                                ? _c("ConfiguratorStepBundleDialog", {
                                    on: { stepChange: _vm.currentPageChange }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.bundleSortedCategories, function(
                                categoryKey
                              ) {
                                return [
                                  _c("ConfiguratorStepBundleContent", {
                                    key: categoryKey + "-stepContent",
                                    attrs: {
                                      "order-delta":
                                        _vm.currentProduct.categories.length -
                                        1,
                                      "bundle-product": _vm.bundleProduct,
                                      "current-product": _vm.currentProduct,
                                      "bundle-id": _vm.bossBundleId,
                                      "category-key": categoryKey,
                                      first: false,
                                      last: _vm.lastStepBundle(categoryKey),
                                      "current-step": _vm.currentCategory,
                                      "lock-next-step": _vm.lockNextStep
                                    },
                                    on: { stepChange: _vm.currentPageChange }
                                  })
                                ]
                              })
                            ],
                            2
                          )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/configurator/components/Configurator.vue?vue&type=template&id=92566b70&
// module id = null
// module chunks = 